import TitleText from '../../atomsLegacy/typography/TitleText';
import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckboxLabel = styled(TitleText)`
  margin-left: 5px;
`;
